import script from "./PendingPaymentsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingPaymentsPage.vue?vue&type=script&setup=true&lang=js"

import "./PendingPaymentsPage.vue?vue&type=style&index=0&id=ab3f433a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab3f433a"]])

export default __exports__